export default __webpack_public_path__ + "static/media/worksheet3.12634792.jpg";